'use strict';

/**
 * Validates the billing address form and updates the checkout view
 */
function billingAddressValidation() {
    var $billingForm = document.querySelector('.card-body [id=dwfrm_billing]');

    if (!$billingForm.checkValidity()) {
        $billingForm.reportValidity();

        //Scroll to empty form for billing for customer to fill in
        document.querySelector('.btn-add-new').click();
        document.querySelector('.payment-manual-address').click();
        document.querySelector('.payment-form').scrollIntoView({ behavior: 'smooth', block: 'start' });

        return false;
    }

    return true;
}

module.exports = {
    billingAddressValidation
};
